import { motion, useTransform } from "framer-motion";

export default function Mountains({ progress }) {
  const yFar = useTransform(progress, [0, 1], ["0%", "18%"]);
  const yMid = useTransform(progress, [0, 1], ["0%", "10%"]);
  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[55%]" aria-hidden="true">
      <motion.svg style={{ y: yFar }} viewBox="0 0 1440 400" preserveAspectRatio="none" className="absolute inset-0 h-full w-full">
        <path d="M0 260 L120 190 L210 230 L330 120 L420 200 L520 150 L600 210 L720 80 L820 190 L930 130 L1040 210 L1160 110 L1270 200 L1360 160 L1440 210 L1440 400 L0 400Z" fill="#77C8D3" opacity="0.45" />
      </motion.svg>
      <motion.svg style={{ y: yMid }} viewBox="0 0 1440 400" preserveAspectRatio="none" className="absolute inset-0 h-full w-full">
        <path d="M0 300 L160 240 L260 280 L400 210 L520 270 L640 230 L780 290 L900 220 L1030 280 L1180 230 L1300 280 L1440 250 L1440 400 L0 400Z" fill="#77C8D3" />
      </motion.svg>
      <svg viewBox="0 0 1440 400" preserveAspectRatio="none" className="absolute inset-0 h-full w-full">
        <path d="M0 340 L200 300 L360 330 L520 290 L700 340 L880 300 L1060 335 L1240 300 L1440 330 L1440 400 L0 400Z" fill="#007D6C" />
      </svg>
      <div className="mist absolute inset-0" />
    </div>
  );
}
